import React, { useContext } from 'react';
import { ModalContext } from 'App';
import RejectConfirmationModal from '../modals/RejectConfirmationModal';

const useRejectConfirmation = (
  isLoading,
  isStartAssessment,
  transactionStatus,
  applicationStatus,
  id
) => {
  const setModal = useContext(ModalContext);
  const isStatusAllowed = ['ONGOING'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['ONGOING'].indexOf(applicationStatus) > -1;

  const isAllowed =
    true && isStatusAllowed && isApplicationStatusAllowed && isStartAssessment;
  const onHandleClick = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <RejectConfirmationModal id={id} />,
      title: `Reject Application`,
      modalSize: 'modal-md',
    });
  };

  const component = isAllowed ? (
    <div className="mx-2 mb-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-danger font-weight-bold"
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Reject
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default useRejectConfirmation;
